import { render, staticRenderFns } from "./AddContractProvider.vue?vue&type=template&id=2383bb8f&scoped=true&"
import script from "./AddContractProvider.vue?vue&type=script&lang=ts&"
export * from "./AddContractProvider.vue?vue&type=script&lang=ts&"
import style0 from "./AddContractProvider.vue?vue&type=style&index=0&id=2383bb8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383bb8f",
  null
  
)

export default component.exports